module.exports = __webpack_public_path__ + "img/coque-off.739e3165.svg";